import { createContext, PropsWithChildren, useRef } from 'react'
import { find } from 'lodash'
import { createStore } from 'zustand'

import { WPPageData } from '@/types'

export type SchemaProps = {
  schema?: WPPageData['yoast_head_json']['schema']
}

export type SchemaStore = ReturnType<typeof createAppStore>

const createAppStore = (initProps?: Partial<SchemaProps>) => {
  return createStore<SchemaProps>()(() => ({ ...initProps }))
}

export const SchemaContext = createContext<SchemaStore | null>(null)

function SchemaProvider({ children, ...props }: PropsWithChildren<SchemaProps>) {
  const storeRef = useRef<SchemaStore>(null)

  if (!storeRef.current) {
    storeRef.current = createAppStore(props)
  }

  return <SchemaContext.Provider value={storeRef.current}>{children}</SchemaContext.Provider>
}

export const getTitleFromSchema = (schema?: WPPageData['yoast_head_json']['schema']) => {
  const graph = find(schema?.['@graph'], { '@type': 'BreadcrumbList' })
  return graph?.itemListElement[graph?.itemListElement.length - 1]
}

export default SchemaProvider
